import { Component, ElementRef, HostListener, inject, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { EmailSenderService } from "../../data/services/email-sender.service";

@Component({
    selector: 'app-header',
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    standalone: false
})
export class HeaderComponent {

    public isScrolled: boolean = false;
    public isOpened: boolean = false;

    public emailSender: EmailSenderService = inject(EmailSenderService);

    @ViewChildren("menuItem", { read: ElementRef }) menuItems: QueryList<ElementRef<HTMLDivElement>>;
    @ViewChild("menuLink") menuLink: ElementRef<HTMLDivElement>;
    @ViewChild("navLink") navLink: ElementRef<HTMLDivElement>;

    @HostListener('document:scroll', ['$event'])
    onScroll(event: any) {
        this.isScrolled = 150 < window.scrollY;
    }

    @HostListener('document:mousedown', ['$event'])
    onGlobalClick(event: any): void {
        if(!this.isOpened) return;

        if (
            !this.navLink.nativeElement.contains(event.target)
        ) {
            this.isOpened = false;
        }
    }

    public toggleMenu = () => {
        this.isOpened = !this.isOpened;
    }

    public downloadPdf = () =>{
        try {
            const url = 'assets/documents/Házirend.pdf';
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Házirend.pdf';
            a.click();
            a.remove();
        } catch (err) {
            console.error('PDF letöltési hiba', err);
        }
    }
}